<template>
  <div
    class="table-cell table-trend-cell"
    :class="classes"
    @click="value !== null ? onClick : null"
  >
    <!-- {{ $localeNumber(value, 1) }} -->
    <TrendArrow
      v-if="value !== null"
      :id="`trend-tooltip-${group.name + name}`"
      :class="classes"
      :title="title"
      :type="name"
      :averages="averages"
      :regressionValues="regressionValues"
      :theme="group.theme"
      :useColor="true"
      :zeroToHundred="zeroToHundred"
      :shouldShowNoTrendDash="true"
    />
  </div>
</template>

<script>
import { Tooltip } from 'bootstrap'

import TrendArrow from '@/components/shared/TrendArrow.vue'
export default {
  name: 'PulsTableTrendCell',
  components: {
    TrendArrow
  },
  props: {
    group: {
      type: Object,
      required: true
    },
    template: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    result: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: null
    },
    onCellClick: {
      type: Function,
      default: () => {}
    },
    regressionValues: {
      type: Array,
      default: () => []
    },
    averages: {
      type: Array,
      default: () => []
    },
    zeroToHundred: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    classes() {
      if (this.value === null) {
        return ''
      } else if (this.template === 'categories' || this.template === 'tags') {
        return 'cursor-pointer'
      }
      return ''
    }
  },
  methods: {
    onClick() {
      // find and hide tooltip with id `trend-tooltip-${group.name + name}`
      const tooltipEl = document.getElementById(
        `trend-tooltip-${this.group.name + this.name}`
      )
      const tooltipInstance = Tooltip.getInstance(tooltipEl)
      if (tooltipInstance) {
        tooltipInstance.hide()
      }
      this.onCellClick(this.template, this.name)
    }
  }
}
</script>
